import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="image, heading, text" width="33%" theme="light" className="context" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/express/embed-sdk/assets/aec5c39427465257aa990c386b36632b/benefit-blade-1.svg",
        "alt": "MSFT Teams logo"
      }}></img></p>
    <h3 {...{
      "id": "enable-users-to-make-unique-content"
    }}>{`Enable users to make unique content.`}</h3>
    <p>{`Users of all skill levels can create standout content leveraging Adobe’s world class editing and AI tools.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="context" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/express/embed-sdk/assets/2d57ea7c5d81c4ff62b02076117c6ea8/benefit-blade-2.svg",
        "alt": "JIRA Cloud logo"
      }}></img></p>
    <h3 {...{
      "id": "keep-your-users-in-context"
    }}>{`Keep your users in context.`}</h3>
    <p>{`Supply your users with the tools to complete creative tasks without leaving your web app.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="context" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/express/embed-sdk/assets/c623d0e70f62e76a582b81fac0e00c02/benefit-blade-3.svg",
        "alt": "Slack logo"
      }}></img></p>
    <h3 {...{
      "id": "get-powerful-tools-right-out-of-the-box"
    }}>{`Get powerful tools, right out of the box.`}</h3>
    <p>{`Save valuable development time using our prebuilt editing modules, taking days not months to integrate.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      